export default __webpack_public_path__ + "static/media/about-home.5feebeb4.jpg";